import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export default function LevelIndicatorNode(props) {
    const { data } = props;
    const v = parseFloat(data?.liveValue ?? 0);
    const config = data?.config || {};
    const min = parseFloat(config.min_value ?? 0);
    const max = parseFloat(config.max_value ?? 100);
    const pct = Math.min(1, Math.max(0, (v - min) / (max - min || 1)));
    const color = pct > 0.8 ? '#EF4444' : pct > 0.5 ? '#F59E0B' : '#22C55E';
    const w = data?.width || 30;
    const h = data?.height || 80;
    return (
        <BaseScadaNode {...props}>
            <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} style={{ display: 'block' }}>
                <rect x={4} y={4} width={w - 8} height={h - 16} rx={3} fill="#1E293B" stroke="#475569" strokeWidth={1.5} />
                <rect x={6} y={4 + (h - 16) * (1 - pct)} width={w - 12} height={(h - 16) * pct} rx={2} fill={color} opacity={0.85} />
                <text x={w / 2} y={h - 4} textAnchor="middle" fill="#94A3B8" fontSize={8}>{isNaN(v) ? '--' : `${Math.round(pct * 100)}%`}</text>
            </svg>
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
